<template>
  <div class="outer-box">
    <div class="me-wrapper" v-if="ifvalid">
      <div class="project-base-info" v-show="contract_data.complete_time">
      <p class="content">
      完成时间：{{contract_data.complete_time?contract_data.complete_time:''}}<img :src="imgUrl" alt="" ></p>
      </div>
      <div class="progress-info-wrapper">
        <div class="progress-box">
          <p class="title">分解任务状态</p>
          <div v-for="(ele,index) in columnsSelectionData" :key="index+'duty'" class="duty-wrapper">
            <p>{{ele.type==="report"?"编制报告":"检测实施"}}（{{ele.content}}）-{{getChoice(ele.option)}}</p>
            <p class="right">{{ele.stat}}{{ele.owner_name?"("+ele.owner_name+")":""}}</p>
          </div>
          <Table :columns="columnsSelectionBar" :data="columnsSelectionData"></Table>
        </div>
        <div class="progress-box">
          <p class="title">项目操作流水</p>
              <div v-for="ele in op_content" :key="ele.id" class="detail-ele">
                <p class="time-span">{{ele.op_time}}</p>
                <p>{{ele.op_text}}</p>
              </div>
        </div>
      </div>
    </div>
    <div v-else class="null-wrapper">
      <van-loading type="spinner" color="#1989fa"  class="spin" v-if="spinStat"/>
        <p class="null-text" v-else>未查到相关记录</p>        
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
export default {
  name: "contractStat",
  components: {},
  data() {
    return {
        ifvalid:false,
        spinStat:true,
      op_content: [],
      contract_data: { sample: [],customer:{customerCompany:{}},reportInfo:{} },
      imgUrl: process.env.BASE_URL + "img/complete.png",
      sampleDo:{},
       columnsSelectionBar: [
        {
          title: "类型",
          align: "center",
          width:85,
          render: (h, params) => {
            if (params.row.type === 'report') {
              return h("div", [
                h(
                  "span",
                  {
                    props: {
                      size: "small"
                    },
                    style: {
                      color: "#000"
                    }
                  },
                  '报告编制'
                ),
              ]);
            }else if(params.row.type === 'ins'){
              return h("div", [
                h(
                  "span",
                  {
                    props: {
                      size: "small"
                    },
                    style: {
                      color: "#000"
                    }
                  },
                  '检测实施'
                ),
              ]);
            }
          }
        },
        {
          title: "内容",
          align: "center",
          key: "content",
          width:120
        },
        {
          title: "选项",
          align: "center",
          render: (h, params) => {
            if (params.row.option.choice === undefined) {
              return h("span", {}, params.row.option);
            } else {
              return h("div", [
                h(
                  "span",
                  {
                    props: {
                      size: "small"
                    },
                    style: {
                      color: "green"
                    }
                  },
                  params.row.option.choice.text
                ),
                params.row.option.single_choice.map(val =>
                  h(
                    "span",
                    {
                      props: {
                        size: "small"
                      },
                      style: {
                        color: "green"
                      }
                    },
                    "（" + val.text + "）"
                  )
                ),
                params.row.option.multi_choice.map(val =>
                  h(
                    "span",
                    {
                      props: {
                        size: "small"
                      },
                      style: {
                        color: "green"
                      }
                    },
                    "、" + val.text
                  )
                )
              ]);
            }
          }
        },
        {
          title: "状态",
          align: "center",
          key: "stat",
          width: 75
        },
        
        {
          title: "执行者",
          align: "center",
          width: 80,
          key: "owner_name"
        }
      ]
    };
  },
  props: {
    project_display_no: {
      type: String,
      default: "0"
    }
  },
  created() {
    this.get_data();
  },
  beforeRouteUpdate() {},
  computed: {
    columnsSelectionData: function() {
      let resList = [];
      let tmp = {};
      for (let ele of this.sampleDo.reportList) {
        tmp = {};
        tmp.id = ele.id;
        tmp.content = ele.display_no;
        tmp.option = "-";
        tmp.remark = ele.remark;
        tmp.stat = ele.stat;
        tmp.owner_name = ele.full_name;
        tmp._disabled = Boolean(ele.owner);
        tmp.amount = "-";
        tmp.type = "report";
        resList.push(tmp);
      }
      for (let ele of this.sampleDo.insList) {
        tmp = {};
        tmp.id = ele.id;
        tmp.content = ele.product_name;
        tmp.remark = ele.remark;
        tmp.owner_name = ele.full_name;
        tmp.stat = ele.stat;
        tmp.amount = JSON.parse(ele.product_data).amount;
        tmp.option = JSON.parse(ele.product_data);
        tmp.type = "ins";
        tmp._disabled = Boolean(ele.owner);
        resList.push(tmp);
      }
      return resList;
    },
  },
  methods: {
    get_data(no = "0") {
      if (no === "0") {
        no = this.project_display_no;
      }
      this.$axios
        .post(this.$url + "/query_content", {
          project_display_no: no,
          userToken: userToken,
          askData: "contractStat"
        })
        .then(response => {
            if(response.data.stat==='ok'){
                this.ifvalid = true;
                this.spinStat = false;
                this.op_content = response.data.res_record.opList;
                this.contract_data = response.data.res_record.contract_detail;
                this.sampleDo = response.data.res_record.task;
            }
          
        });
    },
    getChoice(val){
       if (val.choice === undefined) {
              return val;
            } else {
              return val.choice.text;
                
            }

    }
  }
};
</script>
<style scoped>
.outer-box{
  padding: 0.8rem 0;
}
.project-base-info {
  width: 100%;
  margin:0;
  text-align: left;
  position: relative;
  height:3rem;
  line-height: 3rem;
  font-size:0.8rem;
}
.project-base-info img{
  position: absolute;
  width:3rem;
  right:0;
  top:0.5rem;
}

p{
  margin:0;
  padding: 0;
}

.title{
  font-weight:800;
  color:#222;
  margin:0.3rem 0;
}
.progress-box {
  width: 100%;
  font-size:0.6rem;
  border-top:1px solid #222;
  padding:0.2rem 0.1rem;
}

.time-span{
  margin-left:-0.2rem;
  color:#888;
}

.null-wrapper{
    min-height:600px;
    text-align: center;
    line-height: 5rem;
    font-size:0.8rem;
    color:#222;
}

.detail-ele{
  padding: 0.2rem 0.3rem;
}

.right{
  text-align: right;
}
.duty-wrapper{
  border-top:1px solid #bbb;
  padding: 0.4rem 0;
  margin:0 0.2rem;
}
.content{
  margin:0 0.3rem;
}

.null-text{
  color:#aaa;
}

</style>